(() => {
  const STEEL_SELECTOR = '[data-sz-steel-choice]';
  const PICKER_SELECTOR = 'variant-radios, variant-selects';
  const WRAPPER_CLASS = 'sz-make-your-pick';
  const observers = new WeakMap();
  const schedules = new WeakMap();

  const getRoots = (scope = document) => {
    const roots = [];
    if (scope?.matches?.('product-info')) roots.push(scope);
    scope?.querySelectorAll?.('product-info').forEach((root) => roots.push(root));
    return roots;
  };

  const ensureSteelLabel = (card) => {
    const step = card?.querySelector('.sz-steel-choice__step');
    if (!step) return;

    let selectedLabel = step.querySelector('[data-sz-steel-selected]');
    if (!selectedLabel) {
      step.textContent = 'Steel: ';
      selectedLabel = document.createElement('span');
      selectedLabel.className = 'sz-steel-choice__selected';
      selectedLabel.dataset.szSteelSelected = '';
      step.append(selectedLabel);
    }

    const selected = card.querySelector('[data-sz-steel-input]:checked');
    selectedLabel.textContent = selected?.value ? `BAUER ${selected.value}` : 'Choose one';
  };

  const normalizeSteelCard = (root, card) => {
    if (!root || !card) return;

    card.classList.add('sz-steel-choice--in-pick');
    ensureSteelLabel(card);

    const options = card.querySelector('.sz-steel-choice__options');
    const fitLine = card.querySelector('.sz-steel-choice__fit-line');
    if (options && fitLine && options.nextElementSibling !== fitLine) {
      options.insertAdjacentElement('afterend', fitLine);
    }

    root.querySelectorAll('.sz-service-addon__step').forEach((step) => {
      step.textContent = '02 OPTIONAL UPGRADE';
    });
  };

  const integrate = (root) => {
    if (!root) return;

    const card = root.querySelector(STEEL_SELECTOR);
    const picker = root.querySelector(PICKER_SELECTOR);
    if (!card || !picker) return;

    let wrapper = picker.parentElement?.classList.contains(WRAPPER_CLASS)
      ? picker.parentElement
      : root.querySelector(`.${WRAPPER_CLASS}`);

    if (!wrapper) {
      wrapper = document.createElement('div');
      wrapper.className = WRAPPER_CLASS;
      picker.parentNode?.insertBefore(wrapper, picker);
      wrapper.append(picker);
    } else if (picker.parentElement !== wrapper) {
      wrapper.prepend(picker);
    }

    if (card.parentElement !== wrapper || card.previousElementSibling !== picker) {
      picker.insertAdjacentElement('afterend', card);
    }

    normalizeSteelCard(root, card);
  };

  const schedule = (root) => {
    if (!root) return;

    const current = schedules.get(root);
    if (current?.frame) window.cancelAnimationFrame(current.frame);
    if (current?.timer) window.clearTimeout(current.timer);

    const state = {};
    state.frame = window.requestAnimationFrame(() => {
      integrate(root);
      const active = schedules.get(root);
      if (active === state) state.frame = 0;
    });
    state.timer = window.setTimeout(() => {
      integrate(root);
      if (schedules.get(root) === state) schedules.delete(root);
    }, 140);
    schedules.set(root, state);
  };

  const observe = (root) => {
    if (!root || observers.has(root)) return;

    const observer = new MutationObserver((mutations) => {
      const needsSync = mutations.some((mutation) =>
        Array.from(mutation.addedNodes || []).some((node) =>
          node.nodeType === 1 && (
            node.matches?.(PICKER_SELECTOR) ||
            node.querySelector?.(PICKER_SELECTOR) ||
            node.matches?.(STEEL_SELECTOR) ||
            node.querySelector?.(STEEL_SELECTOR)
          )
        )
      );
      if (needsSync) schedule(root);
    });

    observer.observe(root, { childList: true, subtree: true });
    observers.set(root, observer);
  };

  const init = (scope = document) => {
    getRoots(scope).forEach((root) => {
      if (!root.querySelector(STEEL_SELECTOR)) return;
      integrate(root);
      observe(root);
    });
  };

  document.addEventListener('change', (event) => {
    const root = event.target.closest?.('product-info');
    if (!root?.querySelector(STEEL_SELECTOR)) return;

    if (event.target.matches?.('[data-sz-steel-input]')) {
      ensureSteelLabel(root.querySelector(STEEL_SELECTOR));
      schedule(root);
      return;
    }

    if (event.target.matches?.('variant-radios input[type="radio"], variant-selects select, variant-selects input[type="radio"]')) {
      schedule(root);
    }
  });

  document.addEventListener('shopify:section:load', (event) => init(event.target));

  init();
  window.setTimeout(() => init(), 180);
})();
